import { MyRoleInfo } from "../../../canvas/MyRoleInfo";
import { PropertyStripLayout } from "../../../canvas/properties/PropertyStripLayout";
import { herdToElement } from "../../herding/HerdingCommands";
import { ActivityFrameAddon } from "./ActivityFrameAddon";

export const ActivityFrameAddonPropertyLayout = PropertyStripLayout<ActivityFrameAddon>((d, s, o, w, a) => {
    const { canManage } = s.get(MyRoleInfo);
    if (!canManage) return [];

    return [
        // Visibility
        w.createButton({
            text: 'Visible/Hidden',
            image: 'deqo://icons/i8/eye-hide',
            onAction() {
                o.update(u => {
                    a.set('hidden', !a.get('hidden'))
                });
            }
        }),
        // Visibility
        w.createButton({
            text: 'Focus Everyone',
            image: 'deqo://icons/i8/herd',
            onAction() {
                d(herdToElement, [a.first()?.parentFrame?.id]);
            }
        })
    ]
});